import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div className="mjwi-footer">
                <div className="mjwi-footer-copyright">
                    <a href="https://devspecial.com/" target="_blank">DevSpecial.com</a>
                </div>

                <div className="mjwi-footer-links">
                <a href="https://devspecial.com/term-privacy-policy/" target="_blank">Terms and Privacy Policy</a>
                </div>
            </div>
        );
    }
}
export default Footer;
